module.exports = __webpack_public_path__ + "build/desktop/img/Zoom.1e1338e33571c99d400dbb79a8f18a75.svg";